import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/revenue")({
  head: () => ({
    meta: [
      { title: "Revenue overview · Landoo Super Admin" },
      { name: "description", content: "Revenue overview — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Revenue overview" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Revenue overview"
        description="Super admin management surface for Revenue overview."
      />
    </DashboardShell>
  ),
});
